import React from 'react';
import BackIcon from '@material-ui/icons/ChevronLeft';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';

export const HistoryDisplayPres = ({ history, backUrl, historyList, onChange, isOpen, trackClickAnalytics, type }) => {
  const onBack = () => {
    if (backUrl) {
      return history.push(backUrl);
    }
    history.goBack();
  };

  let className = '';
  if (type) {
    className = type;
  }

  return (
    <div className="history-display-wrapper">
      <Button
        styleType={'back-button'}
        onClick={event => {
          onBack();
          //trackClickAnalytics(event, 'back button', `${window.location.pathname} back button`);
        }}>
        <div className={'history-display-button-wrapper ' + className}>
          <div>
            <BackIcon className="history-display-icon" />
          </div>
          <div className="history-display-text">{intl.get('default.label.back')}</div>
        </div>
      </Button>
    </div>
  );
};

export default HistoryDisplayPres;
